import { ElementProps } from '@/components/sections/builder/types';
import React from 'react';
import { ElementDataType } from './types';
import { cn, extractYouTubeVideoId } from '@/lib/utils';
import useMediaQuery from '@/hooks/useMediaQuery';

export default function ElementContent({ element }: ElementProps) {
  const content = element.data as ElementDataType;

  const videoUrl =
    useMediaQuery(content.mobileMinWidth) && content.mobileVideo
      ? content.mobileVideo
      : content.video;

  const youtubeVideoUrl =
    useMediaQuery(content.mobileMinWidth) && content.youtubeMobileVideo?.trim()
      ? content.youtubeMobileVideo
      : content.youtubeVideoUrl;

  const findYoutubeId = extractYouTubeVideoId(youtubeVideoUrl ?? '');

  return (
    <>
      <section className={cn('theme_layout_page_width mx-auto bg-white duration-100')}>
        <div className={cn(content.layout === 'full' ? 'video-full-width' : 'px-4')}>
          <div className='w-full contact_form_wrapper video-padding' data-animation='true'>
            {!content.isYoutubeVideo ? (
              <div className='w-full'>
                <video
                  src={videoUrl}
                  className='theme_media h-[390px] w-full object-cover object-center md:h-full'
                  loop={content.loop}
                  autoPlay={content.autoplay}
                  controls={content.controls}
                  muted={content.mute}
                />
              </div>
            ) : (
              <div className='w-full'>
                <iframe
                  height={600}
                  src={`https://www.youtube.com/embed/${findYoutubeId}`}
                  allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                  className='object-contain w-full aspect-square'
                ></iframe>
              </div>
            )}
          </div>
        </div>
      </section>
      <style jsx>
        {`
          @media (min-width: 768px) {
            .video-padding {
              padding-top: ${content.padding?.top || 0}px;
              padding-bottom: ${content.padding?.bottom || 0}px;
              padding-left: ${content.layout === 'full' ? 0 : content.padding?.left || 0}px;
              padding-right: ${content.layout === 'full' ? 0 : content.padding?.right || 0}px;
            }
          }

          .video-full-width {
            position: relative;
            left: 50%;
            right: 50%;
            margin-left: -50vw;
            margin-right: -50vw;
            width: 100vw;
          }
        `}
      </style>
    </>
  );
}
